import { User } from '@app/users';
import { Avatar, Card } from '@material-ui/core';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { NavLink } from 'react-router-dom';

interface MyAccountUserCardProps {
  user: User;
  loading: boolean;
}

export const MyAccountUserCard = ({
  user,
  loading
}: MyAccountUserCardProps) => {
  return (
    <Card className="py-3 px-4">
      {loading ? (
        <Skeleton height={30} count={4} />
      ) : (
        <>
          <div className="row pt-4">
            <div className="col">
              <Avatar className="p-5 h1 text-primary bg-light">
                {user?.name?.charAt(0).toUpperCase()}
              </Avatar>
            </div>
          </div>
          <div className="row py-3 h3 my-0">
            <div className="col">
              <span>{user?.name}</span>
              <span className="text-primary"> - {user?.employee_id}</span>
            </div>
          </div>
          <div className="row py-2">
            <div className="col flex-left">
              <i className="las la-envelope text-primary mr-2"></i>
              <span>{user?.email}</span>
            </div>
          </div>
          <div className="row py-2">
            <div className="col flex-left">
              <i className="las la-mobile text-primary mr-2"></i>
              <span>{user?.phone}</span>
            </div>
          </div>
          <div className="row py-2">
            <div className="col flex-left">
              <i className="las la-industry text-primary mr-2"></i>
              <span>{user?.company}</span>
            </div>
          </div>
          <div className="row py-2">
            <div className="col flex-left">
              <i className="las la-user text-primary mr-2"></i>
              <span>{user?.title}</span>
            </div>
          </div>
          <div className="row py-2">
            <div className="col flex-left">
              <i className="las la-laptop text-primary mr-2"></i>
              <span>{user?.role}</span>
            </div>
          </div>
          <div className="row pt-2 pb-4">
            <div className="col flex-left">
              <i className="las la-at text-primary mr-2"></i>
              <span>{user?.email}</span>
            </div>
          </div>
          <div className="row pb-3 ">
            <div className="col-9 flex-left">
              {/* <NavLink
                to="/spa/my-account/personal-information"
                className="p-3 w-100 flex-left"
                activeClassName="bg-light text-primary rounded"
              >
                <i className="las la-user mr-3"></i>
                <span>Personal information</span>
              </NavLink> */}
            </div>
          </div>
        </>
      )}
    </Card>
  );
};
